import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useQueryAssistanceRequestDetail = (id: number | string | undefined) => {
  return useQuery({
    queryKey: ["assistance-request-detail", id],
    queryFn: async () => {
      const { data } = await axios.get(`assistance_requests/${id}`);
      return data;
    },
    retry: 0,
    enabled: !!localStorage.getItem('Authorization') && !!id,
  });
};
